var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThunderbolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "thunderbolt-filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-124.000000, -306.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "thunderbolt-filled",
    transform: "translate(124.000000, 306.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.875,8.42109375 L14.7117187,8.42109375 L19.3546875,2.5546875 C19.4507812,2.43046875 19.3640625,2.25 19.2070312,2.25 L10.21875,2.25 C10.153125,2.25 10.0898438,2.28515625 10.0570313,2.34375 L3.984375,12.8320313 C3.91171875,12.95625 4.00078125,13.1132813 4.14609375,13.1132813 L8.23359375,13.1132813 L6.13828125,21.4945313 C6.09375,21.6773438 6.3140625,21.80625 6.45,21.675 L20.0039062,8.7421875 C20.1257812,8.62734375 20.04375,8.42109375 19.875,8.42109375 Z",
    id: "\\u8DEF\\u5F84"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderbolt);
export default __webpack_public_path__ + "static/media/thunderbolt.eb7faf7f9e34f46cbf3c2e81c184dc52.svg";
export { ForwardRef as ReactComponent };